import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { BehaviorSubject, } from 'rxjs';
import { platformSettings } from 'src/app/models/platformSettings';
import { AppSettingsService } from './app-settings.service';
import { User } from 'src/app/models/user';
import { environment } from 'src/environments/environment.prod';
import { throwError }  from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {
  protected deploymentApiUrl = AppSettingsService.appSettings.DeploymentsApiUrl;
  protected assureLoginURL = AppSettingsService.appSettings.AssureLoginUrl;
  protected assureAPIUrl = AppSettingsService.appSettings.AssureAPIUrl;
  protected documentationAPI = AppSettingsService.appSettings.DocumentationAPIUrl;
  protected helpUrl = AppSettingsService.appSettings.HelpUrl;

  platformSettings: platformSettings = JSON.parse(sessionStorage.getItem('token'));

  private _user = new BehaviorSubject<User>(null);
  private dataStore: { user: User } = { user: null };
  readonly user = this._user.asObservable();

  private loggedIn = new BehaviorSubject<boolean>(false);

  get isLoggedIn() {
    if (sessionStorage.getItem('token') != null) {
      this.loggedIn.next(true);
    } else {
      this.loggedIn.next(false);
    }
    return this.loggedIn.asObservable();
  }

  constructor(private http: HttpClient,
    private router: Router) { }


  public async login() {
    await this.getUserDetails().then(result => {
      this.loggedIn.next(true);
      this.dataStore.user = result;
      this._user.next(Object.assign({}, this.dataStore).user)
    })
  }

   // function to get access token from return token in query params on first login
   public async ValidateAndGetAccessToken() {
    await this.getAccessToken().then(res => {
      console.log(res['access_token'])
      sessionStorage.setItem('token', res['access_token']);
    });
  }

  public getAccessToken(): Promise<string> {
    try {
      const body = {return_type: 'AccessToken', platform_keyname: sessionStorage.getItem('platformName')};   
      return this.http.post<string>(this.assureAPIUrl + '/verify', body).toPromise();
    } catch (error) {
      catchError(this.handleError);
    }
  }

  getUserDetails(): Promise<User> {
    return this.http.get<User>(this.documentationAPI + "/users/getUser").toPromise();
  }

  public logout() {
    this.loggedIn.next(false);
    sessionStorage.clear();
    this.router.navigate(['/'])
    window.location.reload();
  }

  public handleError(error: HttpErrorResponse) {
    if (!environment.production) {
      console.log(error);
    }
    return throwError(`Error: ${error}`);
  }





}


